import React from 'react';
import ContentLoader from 'react-content-loader';

const CategoryFilterItemLoader = (props: any) => (
    <ContentLoader
        viewBox="0 0 150 42"
        height={42}
        width={150}
        backgroundColor="#ebebeb"
        foregroundColor="#e7e7e7"
        {...props}>
        <rect x="0" y="0" rx="20" ry="20" width="150" height="42" />
    </ContentLoader>
);

export default CategoryFilterItemLoader;
